import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

// Previous / next record on a profile page — the AxisCare arrows.
//
// A list page can hand the profile its ordered ids through router state (the
// Clients list does, so prev/next follows whatever sort and filter the list
// had). But router state is gone after a refresh, and absent entirely when a
// profile is reached from search, the dashboard or a bookmark — which is why
// the arrows used to vanish most of the time. Without state, this fetches the
// full id list itself in the default "Last, First" order, so the arrows are
// always there.
//
//   const nav = useRecordNav({ table: 'clients', id, base: '/clients', stateKey: 'clientIds' });
//   <RecordNav {...nav} />
export default function useRecordNav({ table, id, base, stateKey, filter }) {
  const location = useLocation();
  const navigate = useNavigate();
  const fromState = location.state?.[stateKey];
  const [fetched, setFetched] = useState([]);

  useEffect(() => {
    if (Array.isArray(fromState) && fromState.length > 0) return undefined;
    let live = true;
    let q = supabase.from(table).select('id').order('last_name', { ascending: true }).order('first_name', { ascending: true });
    if (filter) q = filter(q);
    q.then(({ data, error }) => { if (live && !error) setFetched((data || []).map(r => r.id)); });
    return () => { live = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [table, fromState]);

  const ids = Array.isArray(fromState) && fromState.length > 0 ? fromState : fetched;
  const idx = ids.indexOf(id);
  const total = ids.length;
  const hasPrev = idx > 0;
  const hasNext = idx !== -1 && idx < total - 1;
  const go = (i) => navigate(`${base}/${ids[i]}`, { state: { [stateKey]: ids, idx: i } });

  return {
    ids, idx, total, hasPrev, hasNext,
    goPrev: () => hasPrev && go(idx - 1),
    goNext: () => hasNext && go(idx + 1),
  };
}
